import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

// Connects to data-controller="submit"
export default class extends Controller {
  static values = {
    debounce: { type: Number, default: 0 },
  };

  initialize() {
    this.debouncedSubmit = debounce(
      this.performSubmit.bind(this),
      this.debounceValue,
    );
  }

  connect() {
    if (!(this.element instanceof HTMLFormElement)) {
      throw new Error("submit controller must be attached to a form element");
    }
  }

  submit() {
    this.debouncedSubmit();
  }

  performSubmit() {
    this.element.requestSubmit();
  }

  disconnect() {
    this.debouncedSubmit.cancel();
  }
}
